import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/ru";

export const getUserSelector = state => {
  return state.auth.user;
};

export const getChildUserSelector = createSelector(
  [getUserSelector, (state, id) => Number(id)],
  (user, id) => {
    moment.locale("ru");
    const invoices = user.general.invoices
      .filter(item => item.children_id === id)
      .map(item => ({
        ...item,
        month: moment(item.valid_from).format("MMMM"),
        created_at: moment(item.created_at).format("DD.MM.YYYY HH:mm")
      }))
      .reverse();
    const invoiceFilterPaid = invoices.filter(item => item.state.id === 2);
    const scheduleChild = invoiceFilterPaid
      .map(item => item.training.map(el => el.schedule))
      .flat(1)
      .sort(function(a, b) {
        return new Date(a.start) - new Date(b.start);
      })
      .map(item => ({
        ...item,
        day: moment(item.start).format("dddd"),
        startTime: moment(item.start).format("HH:mm"),
        endTime: moment(item.start, "YYYY-mm-dd HH:mm")
          .add(item.duration, "minutes")
          .format("HH:mm"),
        dataString: moment(item.start).calendar(null, {
          sameDay: "[Сегодня]",
          nextDay: "[Завтра]",
          nextWeek: "DD MMMM",
          lastDay: "[yesterday]",
          lastWeek: "[last] dddd",
          sameElse: "DD MMMM"
        })
      }));
    const dayNow = moment().format("YYYY-MM-DD");
    const uniq = {};
    const newScheduleChild = scheduleChild.filter(
      el => moment(el.start).isSame(dayNow) || moment(dayNow).isBefore(el.start)
    );
    const schedule = newScheduleChild.filter(
      obj => !uniq[obj.id] && (uniq[obj.id] = true)
    );
    const child = user.general.children.find(item => item.id === id);
    const birthday = moment(child.birthday).format("DD.MM.YYYY");

    return { ...child, birthday, invoices, schedule };
  }
);

export const getCheckPaidInvoicesClientSelector = createSelector(
  [getUserSelector],
  user => {
    return user.general.invoices.find(item => item.state.id === 1);
  }
);
